import { Component, OnInit } from "@angular/core";
import {
    NgbModalConfig,
    NgbModal,
    NgbModalOptions,
    ModalDismissReasons,
} from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import {
    FormControl,
    FormsModule,
    Validators,
    FormGroup,
} from "@angular/forms";

@Component({
    selector: "app-saved-invoices-pos",
    templateUrl: "./saved-invoices-pos.component.html",
    styleUrls: ["./saved-invoices-pos.component.scss"],
})
export class SavedInvoicesPosComponent implements OnInit {
    invoiceDetails: any;
    closeResult: string = "";
    modalOptions: NgbModalOptions;
    loading: boolean = false;
    invoiceSaved: boolean = false;
    uploadInvoice: boolean = false;
    uploadSuccessful: boolean = false;
    saving: boolean = false;
    displayName: any;
    hasError = false;
    pdfSrc: any;
    fileSizeError = false;
    fileTypeError = false;
    typeError = false;
    sizeError = false;
    supportingDocuments: any[] = [];
    agreed = [{ status: false }];
    invoiceFile: any;
    invoiceDataToSave: any;
    isInvoiceChange: boolean = false;
    isUpdatedData: boolean = false;
    invoiceChanged: boolean = false;
    responseData: any;
    savedInvoice: any;
    _id: any;

    isCondensed: boolean = false;
    currentLayout = {
        isCondensed: true,
    };

    extractedInvoice = new FormGroup({
        invoiceType: new FormControl("e-invoice"),
        file: new FormControl(null),
        supportingFiles: new FormControl(null),
        fileSource: new FormControl(""),
        documentSource: new FormControl(""),
        terms_agreed: new FormControl(null, [Validators.required]),
    });

    validateInvoice(data: any) {
        return this.http.post(
            "https://jsw.qa.payex.live/api/dashboard/uploadInvoice",
            data
        );
    }

    saveInvoice(data: any) {
        return this.http.post(
            "https://jsw.qa.payex.live/api/dashboard/saveInvoiceUploadProcess",
            data
        );
    }

    extractInvoiceData(data: any) {
        return this.http.post(
            "https://jsw.qa.payex.live/api/dashboard/extractInvoiceData",
            data
        );
    }

    getInvoice(data: any) {
        return this.http.post(
            "https://jsw.qa.payex.live/api/dashboard/fetchInvoice",
            data
        );
    }

    constructor(
        private modalService: NgbModal,
        private router: Router,
        private route: ActivatedRoute,
        private http: HttpClient
    ) {
        this.modalOptions = {
            backdrop: "static",
            backdropClass: "customBackdrop",
            scrollable: true,
        };
    }

    toggleSidebar() {
        this.currentLayout.isCondensed = !this.currentLayout.isCondensed;
        document.body.setAttribute(
            "data-sidebar-size",
            this.currentLayout.isCondensed ? "condensed" : "default"
        );
    }

    selectDocuments(event: any) {
        for (var i = 0; i < event.length; i++) {
            if (event[i].type !== "application/pdf") {
                this.typeError = true;
                this.sizeError = false;
            } else if (event[i].size > 5042157) {
                this.sizeError = true;
                this.typeError = false;
            } else {
                this.sizeError = false;
                this.typeError = false;
                this.supportingDocuments.push(event[i]);
            }
        }

        //console.log(this.supportingDocuments);
    }

    /**
     * Delete file from files list
     * @param index (File index)
     */
    deleteFile(index: number) {
        this.supportingDocuments.splice(index, 1);
        if (this.supportingDocuments.length === 0) {
            this.extractedInvoice.patchValue({
                documentSource: "",
            });
        }
    }

    reUploadInvoice(event: any) {
        if (event.length > 0) {
            const fileUploaded = event[0];

            //console.log(fileUploaded);

            if (fileUploaded.type !== "application/pdf") {
                this.hasError = false;
                this.fileSizeError = false;
                this.fileTypeError = true;
            } else if (fileUploaded.size > 5042157) {
                this.fileTypeError = false;
                this.hasError = false;
                this.fileSizeError = true;
            } else {
                this.fileSizeError = false;
                this.fileTypeError = false;

                if (typeof FileReader !== "undefined") {
                    let reader = new FileReader();
                    reader.onload = (e: any) => {
                        this.pdfSrc = e.target.result;
                        //console.log(this.pdfSrc);
                    };
                    let $file: any = fileUploaded;
                    reader.readAsArrayBuffer($file);
                }

                this.extractedInvoice.patchValue({
                    fileSource: fileUploaded,
                });

                this.hasError = false;
                this.isInvoiceChange = true;

                const userData = {
                    req: {
                        emailAddress: "",
                        companyCode: "",
                        purchaseOrg: "",
                        docType: "",
                        items: this.invoiceDetails.items,
                    },
                };

                this.loading = true;
                this.invoiceChanged = true;

                //console.log(userData);

                //console.log(localStorage.getItem("eippSession"));

                const formData: any = new FormData();
                // formData.append('poNo', this.route.snapshot.params['poNo']);
                formData.append(
                    "sellerCode",
                    localStorage.getItem("vendorCode")
                );
                formData.append(
                    "sessionId",
                    localStorage.getItem("eippSession")
                );
                formData.append("invoiceType", "e-invoice");
                formData.append("req", JSON.stringify(userData.req));
                formData.append("file", this.extractedInvoice.value.fileSource);

                // for (const value of formData.values()) {
                //     console.log(value);
                // }

                this.extractInvoiceData(formData).subscribe(
                    (res) => {
                        this.loading = false;
                        this.invoiceChanged = false;
                        this.isUpdatedData = true;
                        this.responseData = res;
                        //console.log(res);
                        if (
                            this.responseData.length !== 0 &&
                            this.responseData.status === "error"
                        ) {
                            console.log(this.responseData.message);
                        } else {
                            //console.log("Success hereresponseData");
                            this.invoiceDetails = this.responseData;
                        }
                    },
                    (error) => {
                        console.log(error.msg);
                    }
                );
            }
        }
    }

    open(content: any) {
        this.modalService.open(content, this.modalOptions).result.then(
            (result) => {
                this.closeResult = `Closed with: ${result}`;
            },
            (reason) => {
                this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
            }
        );
    }

    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return "by pressing ESC";
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return "by clicking on a backdrop";
        } else {
            return `with: ${reason}`;
        }
    }

    saveUploadData() {
        this.loading = true;
        this.saving = true;
        //this.uploadInvoice = false;

        const invoiceData = {
            sellerCode: localStorage.getItem("vendorCode"),
            session: { sessionId: localStorage.getItem("eippSession") },
            data: {
                irn: this.invoiceDetails.irn,
                invoice_number: this.invoiceDetails.invoice_number,
                file_link: this.invoiceDetails.file_link,
                gstin: this.invoiceDetails.gstin,
                invoice_date: this.invoiceDetails.invoice_date,
                invoice_amount: this.invoiceDetails.invoice_amount,
                terms_agreed: false,
                errors: [],
                supporting_docs: this.invoiceDetails.supporting_docs,
                company_code: this.invoiceDetails.company_code,
                purchase_org: this.invoiceDetails.purchase_org,
                doc_type: this.invoiceDetails.doc_type,
                email_address: this.invoiceDetails.email_address,
                items: this.invoiceDetails.items,
            },
        };

        this.saveInvoice(invoiceData).subscribe(
            (res) => {
                this.saving = false;
                this.invoiceSaved = true;
                this.uploadInvoice = false;
                this.uploadSuccessful = false;
                //console.log(res);
            },
            (error) => {
                this.saving = false;
                this.invoiceSaved = true;
                this.uploadInvoice = false;
                this.uploadSuccessful = false;
                //console.log(error);
            }
        );
    }

    onSubmit() {
        this.loading = true;
        this.uploadInvoice = true;

        this.displayName = localStorage.getItem("displayName");
        //this.invoiceDetails = this.invoiceService.getProcessedInvoice();

        const userData = {
            req: {
                companyCode: "",
                purchaseOrg: "",
                docType: "",
                emailAddress: "",
                items: this.invoiceDetails.items,
                termsAgreed: true,
            },
        };

        if (this.isInvoiceChange === true) {
            this.invoiceFile = this.extractedInvoice.value.fileSource;
        } else {
            this.invoiceFile = this.invoiceDetails.file;
        }

        //console.log(localStorage.getItem("eippSession"));

        const formData: any = new FormData();
        formData.append("sellerCode", localStorage.getItem("vendorCode"));
        formData.append("sessionId", localStorage.getItem("eippSession"));
        formData.append("invoiceType", "e-invoice");
        formData.append("req", JSON.stringify(userData.req));
        formData.append("file", this.invoiceFile);

        console.log(this.supportingDocuments + " these docs");

        if (this.supportingDocuments.length !== 0) {
            for (let i = 0; i < this.supportingDocuments.length; i++) {
                formData.append("supportingDocs", this.supportingDocuments[i]);
            }
        } else {
            formData.append(
                "supportingDocs",
                this.invoiceDetails.supporting_docs
            );
        }

        if (!this.saving) {
            this.validateInvoice(formData).subscribe(
                (res) => {
                    this.responseData = res;
                    console.log(this.responseData.status);

                    if (this.responseData.status === "error") {
                        console.log("error exist");
                        this.loading = false;
                        this.uploadInvoice = false;
                        this.hasError = true;
                    } else {
                        this.uploadInvoice = false;
                        this.invoiceSaved = false;
                        this.uploadSuccessful = true;
                    }
                },
                (error) => {
                    this.uploadInvoice = false;
                    this.uploadSuccessful = true;
                    this.invoiceSaved = false;
                    //console.log(error);
                }
            );
        }

        this.modalService.dismissAll();
    }

    ngOnInit(): void {
        this.displayName = localStorage.getItem("displayName");
        const userData = {
            irn: localStorage.getItem("irn"),
            action: "savedGet",
            sellerCode: localStorage.getItem("vendorCode"),
            session: { sessionId: localStorage.getItem("eippSession") },
        };

        this.getInvoice(userData).subscribe(
            (res) => {
                this.loading = false;
                this.responseData = res;
                //console.log(this.responseData);
                if (this.responseData.status === "successful") {
                    // console.log("You did it");
                    this.invoiceDetails = this.responseData.savedInvoice;
                    console.log(this.invoiceDetails);
                } else {
                    this.loading = false;
                    console.log(res);
                    console.log("error");
                }
            },
            (error) => {
                if (error.status === 401) {
                    // this.sessionExpired = true;
                    // this.errorMsg = error.error.msg;
                    this.loading = false;
                    console.log(error);
                }
            }
        );
    }

    closeSuccessDialog() {
        this.loading = false;
        this.router.navigateByUrl("/invoices");
    }

    viewSavedInvoices() {
        this.router.navigate(["/saved-invoices"]);
    }

    onCheckboxChange(e: any) {
        //console.log(e);
        if (e.target.checked) {
            this.extractedInvoice.patchValue({
                terms_agreed: e.target.value,
            });
        } else {
            this.extractedInvoice.patchValue({
                terms_agreed: null,
            });
        }
    }
}
